import { createLogic } from 'redux-logic'
import convertUser from '@app/helpers/convertUser'
import handleErrors from '@app/helpers/handleErrors'
import { SYNC_CURRENT_USER } from '@app/constants/users/currentUser'
import { updateCurrentUser } from '@app/actions/users/currentUser'
import Api from '@app/api/wizard/signIn'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'
import { convertAppConfig } from '@app/helpers/convertAppConfig'
import { saveAppConfig } from '@app/actions/appConig/appConfig'

const fetchCurrentUserLogic = createLogic({
  type: SYNC_CURRENT_USER,
  cancelType: API_REQUEST_CANCEL,

  process(_, dispatch, done) {
    const { secrets: { accessToken: { token } } } = store.getState()
    const { users: { currentUser: { user: { ids: { sphere } } } } } = store.getState()
    const { appConfig: { rawConfig } } = store.getState()
    const { unit: { isNCentral, activation } } = store.getState()
    dispatch(apiRequestSent(SYNC_CURRENT_USER))
    Api.signIn(token, sphere)
      .then((response) => {
        const { data: { sphere_user } } = response
        const user = convertUser(sphere_user)
        dispatch(updateCurrentUser(user))
        const convertedConfig = convertAppConfig(rawConfig, isNCentral, activation, user.role)
        dispatch(saveAppConfig(convertedConfig))
        dispatch(apiRequestDone(SYNC_CURRENT_USER))
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('signIn failed without error')
        }
      })
      .then(() => done())
  },
})

export default fetchCurrentUserLogic
